import React, { useEffect } from 'react';
import IntroComponent from '../components/Introduction';
import { eventTracking } from '../../Module/marketing';

const MbtiMain = () => {

    useEffect(() => {
        eventTracking.SetGoogleAnalytics();
        eventTracking.SetKakaoPixel();
    }, [])

    return (
        <div className="mbti-wrapper">
            <IntroComponent />
        </div >
    )
}

export default MbtiMain;